'use strict';

exports.__esModule = true;
exports.typeSets = exports.generateHeadingType = exports.generateParagraphType = exports.Type = undefined;

var _ylu2zax = require('./typeSets/ylu2zax');

var _ylu2zax2 = _interopRequireDefault(_ylu2zax);

var _ftw5ybq = require('./typeSets/ftw5ybq');

var _ftw5ybq2 = _interopRequireDefault(_ftw5ybq);

var _hnd6yzk = require('./typeSets/hnd6yzk');

var _hnd6yzk2 = _interopRequireDefault(_hnd6yzk);

var _jgo3mpw = require('./typeSets/jgo3mpw');

var _jgo3mpw2 = _interopRequireDefault(_jgo3mpw);

var _jdd4npp = require('./typeSets/jdd4npp');

var _jdd4npp2 = _interopRequireDefault(_jdd4npp);

var _pom2jme = require('./typeSets/pom2jme');

var _pom2jme2 = _interopRequireDefault(_pom2jme);

var _Type2 = require('./Type');

var _Type3 = _interopRequireDefault(_Type2);

var _paragraphs = require('./typeDefs/paragraphs');

var _paragraphs2 = _interopRequireDefault(_paragraphs);

var _headings = require('./typeDefs/headings');

var _headings2 = _interopRequireDefault(_headings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Type = _Type3.default;

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
/** Kits */

exports.generateParagraphType = _paragraphs2.default;
exports.generateHeadingType = _headings2.default;
var typeSets = exports.typeSets = {
  ylu2zax: _ylu2zax2.default,
  ftw5ybq: _ftw5ybq2.default,
  hnd6yzk: _hnd6yzk2.default,
  jgo3mpw: _jgo3mpw2.default,
  jdd4npp: _jdd4npp2.default,
  pom2jme: _pom2jme2.default
};